// extracted by mini-css-extract-plugin
export default {"calcBtns":"Button_calcBtns__KBDRH","res":"Button_res__vrju8"};